interface StringToColorResult {
    backgroundColor: string;
    foregroundColor: string;
}

function stringToColor(str: string): StringToColorResult {
    let hash = 0;

    for (let i = 0; i < str.length; i += 1) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    let backgroundColor = "#";
    let foregroundColor = "#";

    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;

        backgroundColor += `00${Math.floor((255 + value) / 2).toString(16)}`.slice(-2);
        foregroundColor += `00${Math.floor(value / 2).toString(16)}`.slice(-2);
    }

    const opacity = 0.5;
    backgroundColor += Math.floor(opacity * 255)
        .toString(16)
        .padStart(2, "0");

    return { backgroundColor, foregroundColor };
}

interface StringAvatarResult {
    sx: {
        bgcolor: string;
        color: string;
        border: string;
        width: number;
        height: number;
        borderRadius: string;
    };
    children: string;
}

export default function stringAvatar(name?: string): StringAvatarResult {
    const safeName = name ?? "";
    const { backgroundColor, foregroundColor } = stringToColor(safeName);

    const updateName = safeName.toUpperCase().trim();
    let children = "";

    if (updateName) {
        const nameParts = updateName.split(" ");

        if (nameParts.length >= 2) {
            children = `${nameParts[0][0]}${nameParts[1][0] ?? ""}`;
        } else {
            children = updateName.substring(0, 2);
        }
    }
    return {
        sx: {
            bgcolor: backgroundColor,
            color: foregroundColor,
            border: `2px solid ${foregroundColor}`,
            width: 40,
            height: 40,
            borderRadius: "10px",
        },
        children,
    };

}